import { defineStore } from "pinia";
import {uuid} from "vue-uuid";
export const useApplicationStore = defineStore("application",{
    state:() =>({
        loading: false,
        language: 'de',
        messageItems:[]
    }),
    actions:{
        setLoading(state){
            this.loading = state;
        },
        addMessage(type, message){
            this.messageItems.push({variant: type,text: message,id: uuid.v1()});
        },
        removeMessage(key){
            this.messageItems.splice(this.messageItems.findIndex(item => item.id === key), 1)
        },
        shiftMessage(){
            this.messageItems.shift();
        }
    },
    getters:{
        isLoading(){
            return this.loading;
        },
        getMessageItems(){
            return this.messageItems;
        }
    }
});
